const testimonials = [
  {
    quote:
      "Succinct, applicable, and meaningful. I appreciate the real-life application of how to be prepared for crisis. A must-read for any leader.",
    name: "Dawn",
    role: "Verified Reader · Decision Margin",
  },
  {
    quote:
      "Dr. Avory cuts through the noise with operational clarity. Her framework reshaped how our leadership team thinks about coordination and risk.",
    name: "Public Sector Executive",
    role: "Continuity & Resilience Program",
  },
  {
    quote:
      "Rare to find someone with both the field experience and the research depth. Our team left her workshop with concrete, usable practices.",
    name: "Higher Education Leader",
    role: "Emergency Management",
  },
  {
    quote:
      "Practical, candid, and grounded. Her ability to translate complex operational realities into decisions leaders can act on is unmatched.",
    name: "Healthcare Director",
    role: "Risk & Preparedness",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-24 lg:py-32 border-t border-[#262626] bg-[#0a0a0a]"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-6">
            <div className="overline overline-red mb-6">05 — Testimonials</div>
            <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-[-0.03em] leading-[0.95]">
              What leaders
              <br />
              are <span className="text-[#d92d20]">saying.</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 -m-px">
          {testimonials.map((t, i) => (
            <article
              key={i}
              data-testid={`testimonial-${i}`}
              className="cell p-8 lg:p-10 bg-[#0a0a0a] flex flex-col"
            >
              <span className="font-display text-5xl text-[#d92d20] leading-none mb-4">{"\u201C"}</span>
              <p className="text-white/90 text-[17px] leading-relaxed font-display font-medium tracking-tight flex-1">
                {t.quote}
              </p>
              <footer className="mt-8 pt-6 border-t border-[#262626] flex items-center justify-between">
                <div>
                  <div className="text-sm font-semibold text-white">{t.name}</div>
                  <div className="text-xs text-white/55 mt-1">{t.role}</div>
                </div>
                <span className="font-mono text-xs text-white/30">0{i + 1}/0{testimonials.length}</span>
              </footer>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
